import { createActionsHook } from 'src/lib/sweetState';

import { MultiPromptTemplatesStore } from './MultiPromptTemplatesStore';

export const useMultiPromptTemplateActions = createActionsHook(MultiPromptTemplatesStore);
